import React from 'react';
import Section from '../../Section';
import ProductGalleryMultiUploaderInner from './ProductGalleryMultiUploaderInner';

export default function ProductGalleryMultiUploader({ productId }) {
    return (
        <Section
            id="product-gallery-multi-uploader"
            title="Bulk Upload to Gallery"
            subtitle="Upload multiple images, edit captions later."
            preview={<span>Upload multiple files at once</span>}
        >
            <ProductGalleryMultiUploaderInner productId={productId} />
        </Section>
    );
}
